// extracted by mini-css-extract-plugin
export var container = "_2x-0";
export var icon = "_2x-1";